import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withModal } from '../../../modules/modal/withModal'
import Toolbar from '../../views/listview/Toolbar'
import Text from '../../views/typo/Text'
import ImageListImageEditModal from './ImageListImageEditModal'

class ImageNavbar extends React.Component {
  imagesCount = () =>
    this.props.galleryImages ? this.props.galleryImages.length : undefined

  handleAddImage = () => this.props.showModal()

  render() {
    const imagesCount = this.imagesCount()
    return (
      <Toolbar onAdd={this.handleAddImage}>
        <Text className="subtitle">
          <strong>{imagesCount ? imagesCount : 'No'}</strong> Images
        </Text>
      </Toolbar>
    )
  }
}

export default compose(
  connect(({ portal }) => ({
    portalId: portal._id,
    galleryImages: portal.galleryImages,
  })),
  withModal(ImageListImageEditModal, {
    props: ownProps => ({ 
      portalId: ownProps.portalId,
      imageAspectRatio: 4/3,
      longerWidth: 1600
    }),
  }),
)(ImageNavbar)



// WEBPACK FOOTER //
// ./src/components/templates/image-list/ImageListToolbar.js